import React from 'react';
import PropTypes from 'prop-types';

import WorklogItem from '../WorklogItem';
import WorklogGroupItem from '../WorklogGroupItem';

const ListItem = ({ index, style, data }) => {
  const listItem = data.listItems[index];

  if (listItem?.isWorklogGroup) {
    return (
      <WorklogGroupItem
        index={index}
        style={style}
        data={data}
      />
    );
  }

  return (
    <WorklogItem
      index={index}
      style={style}
      data={data}
    />
  );
};

ListItem.propTypes = {
  index: PropTypes.number.isRequired,
  style: PropTypes.object.isRequired,
  data: PropTypes.shape({
    listItems: PropTypes.object.isRequired,
  }).isRequired,
};

export default ListItem;
